export const content = {
    en:{
        placeholder:'Message iFOREX AI...',
        thank_you_msg:'Thank you for using iFOREX ChatGPT! You may contact us for further help on WhatsApp at <a href="https://api.whatsapp.com/send?phone=913371279140&text=&source=&data?se" target="_blank" rel="noopener">+91 33 7127 9140</a>',
        error_msg:'There was a problem. Please try again later, or contact us via WhatsApp at <a href="https://api.whatsapp.com/send?phone=913371279140&text=&source=&data?se" target="_blank" rel="noopener">+91 33 7127 9140</a>',
        error_msg_400:'Invalid request. Please type a textual formatted question.',
        error_msg_408: 'Request timed out. Please check your connection and try again.'

    },
    hi:{
        placeholder:'संदेश iFOREX AI…',
        thank_you_msg:'iFOREX ChatGPT का उपयोग करने के लिए धन्यवाद! अधिक सहायता के लिए आप हमसे <a href="https://api.whatsapp.com/send?phone=913371279140&text=&source=&data?se" target="_blank" rel="noopener">+91 33 7127 9140</a> पर व्हाट्सएप पर संपर्क कर सकते हैं',
        error_msg:'वहां एक समस्या थी। कृपया बाद में पुनः प्रयास करें, या <a href="https://api.whatsapp.com/send?phone=913371279140&text=&source=&data?se" target="_blank" rel="noopener">+91 33 7127 9140</a> पर व्हाट्सएप के माध्यम से हमसे संपर्क करें',
        error_msg_400:'अमान्य अनुरोध। कृपया एक शाब्दिक प्रारूप प्रश्न टाइप करें।',
        error_msg_408: 'अनुरोध का समय समाप्त। अपने कनेक्शन की जांच करें और पुन: प्रयास करें।'

    },
   
    es:{
        placeholder:'Mensaje iFOREX AI...',
        thank_you_msg:'¡Gracias por utilizar iFOREX ChatGPT! Puedes contactarnos para obtener más ayuda en WhatsApp en el <a href="https://api.whatsapp.com/send?phone=34936268599&text=&source=&data?se=" target="_blank" rel="noopener">+34-936-268-599</a>',
        error_msg:'Había un problema. Inténtalo de nuevo más tarde o contáctanos vía WhatsApp en el <a href="https://api.whatsapp.com/send?phone=34936268599&text=&source=&data?se=" target="_blank" rel="noopener">+34-936-268-599</a>',
        error_msg_400:'Solicitud no válida. Escribe una pregunta con formato de texto.',
        error_msg_408: 'Se agotó el tiempo de espera de la solicitud. Verifica tu conexión y vuelve a intentarlo.'
        
    },
    ko:{
        placeholder:'iFOREX AI에 메시지 보내기...',
        thank_you_msg:'iFOREX ChatGPT를 사용해 주셔서 감사합니다! Line에서 <a href="https://lin.ee/ZKefu8C" target="_blank" rel="noopener">+82-2-3143-9380</a>으로 연락하시면 추가 도움을 받으실 수 있습니다.',
        error_msg:'문제가 발생했습니다. 나중에 다시 시도하거나 Line <a href="https://lin.ee/ZKefu8C" target="_blank" rel="noopener">+82-2-3143-9380</a>으로 문의하세요.',
        error_msg_400:'잘못된 요청입니다. 텍스트 형식의 질문을 입력하세요.',
        error_msg_408: '요청 시간이 초과되었습니다. 연결을 확인하고 다시 시도해주세요.'

    },
    tw:{
        placeholder:'留言 iFOREX AI…',
        thank_you_msg:'感謝您使用 iFOREX ChatGPT！如需有關 Line 的進一步協助，您可以致電 <a href="https://lin.ee/4whi97I" target="_blank" rel="noopener">+30-210-374-2599</a> 聯絡我們',
        error_msg:'有疑問。請稍後重試，或透過 Line <a href="https://lin.ee/4whi97I" target="_blank" rel="noopener">+30-210-374-2599</a> 與我們聯繫',
        error_msg_400:'無效的請求。請輸入文字格式問題。',
        error_msg_408: '請求超時。請檢查您的連線並重試。'

    },
}